<template>
  <td v-if="renderCell && isEditable" :class="className" @click="cellclick">
    <el-input ref="cellinput" class="w-full" v-model="localValue" type="number" :precision="precision" :step="step" size="mini" tabindex="0" @change="change" @blur="blur">
      <template v-if="format.includes('percent')" slot="append"><span>%</span></template>
    </el-input>
  </td>
  <td v-else-if="renderCell" :class="className" @click="cellclick">{{ value }}</td>
  <td v-else-if="renderArrow" :key="'g' + columnIndex" :class="'k-group-cell'" />
  <td v-else-if="columnIndex <= level" key='g-colspan' :colSpan="columnsCount - columnIndex">
    <p class='k-reset'>
      <a @click="onGroupClick" tabIndex='-1' href='#' :class="expanded ? 'k-i-collapse k-icon' : 'k-i-expand k-icon'" />
      {{ groupHeader }}
    </p>
  </td>
</template>
<script>
import { i18n } from '@/i18n'
import { isNumber } from 'lodash'
import getNestedValue from '@/services/functions/getNestedValue'
import { discard } from '@/services/functions/preserve&discard'

export default {
  name: 'number-template',
  emits: {
    click: null
  },
  props: {
    field: String,
    dataItem: Object,
    format: {
      type: String,
      default: 'decimal'
    },
    className: String,
    columnIndex: Number,
    columnsCount: Number,
    rowType: String,
    level: Number,
    expanded: Boolean,
    editor: String,
    curEditField: [String, null],
    editType: {
      type: [String, Boolean],
      default: 'row'
    },
    editField: {
      type: String,
      default: 'inEdit'
    },
    extraparams: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      localValue: '',
    }
  },
  mounted () {
    this.localValue = this.numericValue
    if (this.isEditable && this.curEditField === this.field && this.$refs.cellinput) {
      this.$refs.cellinput.focus()
    }
  },
  watch: {
    numericValue: function (value, oldValue) {
      if (value !== oldValue) {
        this.localValue = value
      }
    },
  },
  computed: {
    renderArrow () {
      var returnValue =
        this.columnIndex === undefined ||
        this.level === undefined ||
        this.columnIndex < this.level ||
        this.columnsCount === undefined ||
        this.rowType !== 'groupHeader' ||
        this.dataItem[this.field] === undefined
      // return returnValue && this.dataItem[this.field]
      return returnValue && this.dataItem[this.field] !== undefined !== undefined
    },
    renderCell () {
      return this.field !== undefined && this.rowType !== 'groupHeader'
    },
    inEdit: function () {
      return getNestedValue(this.editField, this.dataItem) === true
    },
    numericValue: function () {
      const value = getNestedValue(this.field, this.dataItem)
      if (!value && value !== 0) {
        return ''
      }
      return Number.parseFloat(getNestedValue(this.field, this.dataItem))
    },
    value: function () {
      return this.formatNumber(this.numericValue)
    },
    maxPrecision: function () {
      const objFormat = i18n.numberFormats[i18n.locale]?.[this.format]
      if (objFormat) {
        return Math.max(objFormat.minimumFractionDigits, objFormat.maximumFractionDigits)
      }
      return 0
    },
    minPrecision: function () {
      const objFormat = i18n.numberFormats[i18n.locale]?.[this.format]
      if (objFormat) {
        return Math.min(objFormat.minimumFractionDigits, objFormat.maximumFractionDigits)
      }
      return 0
    },
    precision: function () {
      const strValue = this.localValue.toString()
      const decimalsLenght = /[.,]/.test(strValue) ? strValue.split(/[.,]/).at(-1).length : 0
      if (decimalsLenght < this.minPrecision) {
        return this.minPrecision
      }
      if (decimalsLenght > this.maxPrecision) {
        return this.maxPrecision
      }
      return decimalsLenght
    },
    step: function () {
      return Math.pow(10, -this.precision)
    },
    groupHeader () {
      const value = this.value
      if (this.rowType === 'groupHeader') {
        const template = this.extraparams.groupHeaderTemplate
        if (typeof template === 'function') {
          return template(this.dataItem, { value, ...discard([template.name], this.extraparams) })
        }
      }
      return value
    },
    editable: function () {
      return !!this.extraparams.editable
    },
    isCellEditable: function () {
      return this.editType === 'cell'
    },
    isEditable: function () {
      return this.editable && this.inEdit && (!this.isCellEditable || this.curEditField === this.field)
    }
  },
  methods: {
    onClick (e) {
      // @ts-ignore
      this.$emit('click', e, this.dataItem, this.expanded)
    },
    onGroupClick (e) {
      // @ts-ignore
      this.$emit('groupclick', e, this.dataItem, this.expanded)
    },
    change (value) {
      var dataItem, field
      if (typeof value === 'object' &&
        Object.hasOwnProperty.call(value, 'dataItem') &&
        Object.hasOwnProperty.call(value, 'field') &&
        Object.hasOwnProperty.call(value, 'value')) {
        ({ dataItem, field, value } = value)
      } else {
        dataItem = this.dataItem
        field = this.field
        if (typeof value === 'string') {
          value = Number.parseFloat(value)
        }
        value = Number.parseFloat(value.toFixed(this.precision))
      }
      this.$emit('change', { dataItem, field, value })
    },
    blur (e) {
      this.$emit('blur', { dataItem: this.dataItem, event: e })
    },
    cellclick (e) {
      this.$emit('cellclick', { dataItem: this.dataItem, field: this.field, event: e })
    },
    formatNumber: function (strNumber) {
      if (!isNumber(strNumber)) return strNumber
      return i18n.n(strNumber, this.format)
    },
    getNestedValue: getNestedValue
  }
}
</script>

<style scoped>
.bg-success-p{
  background-color: black;
}
</style>
